import styled from 'styled-components';

import { TransparentButton } from 'src/app/components/Elements/Button/TransparentButton';
import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';

const MOBILE_SCREEN_WIDTH = `32.7rem`;
const ARROW_PLACEMENT_TOP = '-1.4rem';
const ARROW_PLACEMENT_SIDES = '-1.4rem';

export const ToolTipContainer = styled.div`
  margin: ${props => props.theme.space.s5};
  position: relative;
`;

export const ToolTipContent = styled.div`
  z-index: ${props => props.theme.zIndices.topThree};
  width: ${MOBILE_SCREEN_WIDTH};
  @media screen and (max-width: 320px) {
    width: 29rem;
  }
  height: auto;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.radii.small};
  padding: ${props => props.theme.space.s5};
  display: flex;
  flex-direction: column;
  &[data-popper-placement^='bottom'] > #arrow {
    top: ${ARROW_PLACEMENT_TOP};
    margin-left: ${props => props.theme.space.s3};
  }
  &[data-popper-placement^='left'] > #arrow {
    right: ${ARROW_PLACEMENT_SIDES};
    margin-left: 0rem;
  }
  &[data-popper-placement^='right'] > #arrow {
    left: ${ARROW_PLACEMENT_SIDES};
    margin-left: 0rem;
  }
`;

export const ToolTipCopyContainer = styled.div`
  margin: ${props => props.theme.space.s5};
  margin-top: ${props => props.theme.space.s2};
`;
export const ToolTipAnchorCopyContainer = styled.span`
  text-align: left;
`;

export const Arrow = styled.div`
  height: 3rem;
  width: 3rem;
  bottom: ${ARROW_PLACEMENT_TOP};
  margin-left: ${props => props.theme.space.s3};
  &:before {
    content: ' ';
    background-color: ${props => props.theme.colors.white};
    position: absolute;
    transform: rotate(45deg);
    height: 3rem;
    width: 3rem;
    border-radius: ${props => props.theme.radii.small};
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme.colors.capsuleBlue90};
  opacity: ${props => props.theme.opacities.overlay};
  z-index: ${props => props.theme.zIndices.topTwo};
  cursor: pointer;
`;

export const CloseIconButton = styled(TransparentButton)`
  align-self: flex-end;
`;

export const CloseIcon = styled(CapsuleIcon)`
  svg {
    path {
      fill: ${props => props.theme.colors.capsuleGreen60} !important;
    }
  }
  align-self: flex-end;
  cursor: pointer;
`;

export const AnchorContainer = styled(TransparentButton)`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
`;

export const InfoIcon = styled(CapsuleIcon)<{ blueFill: boolean; isOpen: boolean }>`
  margin-right: ${props => props.theme.space.s2};
  z-index: ${props => (props.isOpen ? props.theme.zIndices.topThree : 0)};
  display: flex;
  align-self: flex-start;
  path {
    fill: ${props => (props.isOpen ? props.theme.colors.white : '')} !important;
    fill: ${props => (!props.isOpen && props.blueFill ? props.theme.colors.capsuleBlue50 : '')} !important;
  }
`;
